import React from 'react'

import {
  EvidenceEntity,
  Maybe,
  TaskDefinitionEntity,
  TaskEntity
} from '../../../../generated/graphql'
import EvidenceDetails from './EvidenceDetails'
import ReportForm from './ReportForm'

type DataFieldsProps = {
  task: Maybe<TaskDefinitionEntity> | Maybe<TaskEntity>
  evidence?: Maybe<EvidenceEntity>
  editedFrom?: string
}
const DataFields: React.FC<DataFieldsProps> = ({ task, evidence, editedFrom }) => {
  const isTaskDefinition = task?.__typename === 'TaskDefinitionEntity'
  const isTask = task?.__typename === 'TaskEntity'
  return isTaskDefinition ? (
    <ReportForm task={task} evidence={evidence} editedFrom={editedFrom} />
  ) : isTask ? (
    <EvidenceDetails task={task} />
  ) : (
    <></>
  )
}

export default DataFields
